export const load = () => ({
	title: 'Window Insert Replacements',
	showTitle: true,
});
